<template>
  <div class="heardWrap" ref="heardWrap">
    <van-nav-bar>
      <template #right>
        <van-button type="primary" @click="add"><div style="font-size: 20px; color: #fff">+</div></van-button>
      </template>
    </van-nav-bar>
    <van-row>
      <van-col span="18">
        <van-search
          v-model="searchValue"
          placeholder="请输入客户名称"
          clearable
          v-on:search="onSearch"
        />
      </van-col>
        <van-col span="6">
        <van-dropdown-menu>
          <van-dropdown-item title="高级搜索" ref="showAdvBtn">
            <van-cell-group>
              <van-field
                v-model="advCustInfoData.reccreated_show"
                name="reccreated"
                label="创建时间"
                placeholder="请输入创建时间"
                type="text"
                @click="showCalendar = true"
              />
              <van-calendar
                v-model:show="showCalendar"
                type="range"
                :min-date="startMin"
                @confirm="onConfirmDate"
              />
            </van-cell-group>
            <van-row>
              <van-col span="12">
                <van-button
                  type="default"
                  block
                  round
                  @click="advSearch_reset"
                  text="重置"
                >
                </van-button>
              </van-col>
              <van-col span="12">
                <van-button
                  type="danger"
                  block
                  round
                  @click="advSearch_ok"
                  text="确认"
                >
                </van-button>
              </van-col>
            </van-row>
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-col>
    </van-row>
  </div>

  <div ref="listWrap" class="listWrap">
    <listPullRefreshWrap
      ref="listPullRefreshWrapRef"
      :apiFn="fetch"
      :resetList="resetList"
    >
      <van-cell
        v-for="item in list"
        :key="item"
        :title="item.title"
        :value="item.value"
        :label="'填写时间：' + (item.label)"
        :to="{
          path: '/opportunity_winper_add',
          query: { recid: item.pkid },
        }"
      >
        <template #title>
            <div class="div">
              {{item.title}}
            </div>
        </template>
        <template #value>
          <div>
            <div>
              {{item.value}}
            </div>
            <div >
              <span style="color:#323233">总分：</span><span :style="labelClass(item)">{{item.tn_sumscore}}</span>
            </div>
          </div>
        </template>
      </van-cell>
    </listPullRefreshWrap>
  </div>
</template>

<script> 
import { useRouter } from "vue-router";
import { defineComponent, ref, onMounted } from "vue";
import listPullRefreshWrap from "../../../components/listWrap/index.vue";
import { getOppwinList } from "../../../http/api"; 
import { format_datetime_to_timestamp, format_timestamp_to_DateTime } from "../../../utils/date";

export default defineComponent({
  name: 'opportunity_winper_list',
  components: {
    listPullRefreshWrap,
  },
  setup() {
    const router = useRouter();
    const showPopover = ref(false);
    const heardWrap = ref(null);
    const listWrap = ref(null);

    const searchValue = ref("");
    const listPullRefreshWrapRef = ref(null);

    const showAdvBtn = ref(null);
    const advCustInfoData = ref({
        reccreated_show: '',
        reccreated_range: ''
    });
    const showCalendar = ref(false);
    const startMin = ref(new Date("2000-01-01"));

    const add = () => {
      router.push({
          path: "/opportunity_winper_add",
      });
    }

    const onSearch = () => {
        listPullRefreshWrapRef.value.onRefresh();
    };

    const advSearch_reset = () => {
        showAdvBtn.value.toggle(); 
        advCustInfoData.value.reccreated_show = "";
        advCustInfoData.value.reccreated_range = "";

        const pageindex = 1;
        listPullRefreshWrapRef.value.pageindex = pageindex;
        listPullRefreshWrapRef.value.onRefresh();
    };

    const advSearch_ok = () => {
        console.log('advSearch_ok')
        showAdvBtn.value.toggle();

        const pageindex = 1;
        listPullRefreshWrapRef.value.pageindex = pageindex;
        const params = {
            reccreated_range: advCustInfoData.value.reccreated_range,
        };
        listPullRefreshWrapRef.value.onRefresh(params);
    };

    const onConfirmDate = (values) => {
        console.log(values)
         const [start, end] = values;
        showCalendar.value = false;
        advCustInfoData.value.reccreated_range = JSON.stringify({start: format_datetime_to_timestamp(start), end: format_datetime_to_timestamp(end)})
        advCustInfoData.value.reccreated_show = `${format_timestamp_to_DateTime(start)}~${format_timestamp_to_DateTime(end)}`;
    }

    const list = ref([]);
    const resetList = () => {
        list.value = [];
    };

    const fetch = async (params) => {
        console.log(params)
        const { data } = await getOppwinList({
            ...params,
            tn_customer: searchValue.value,
            reccreated_range: advCustInfoData.value.reccreated_range
        })
        return new Promise((res) => {
            if (data && data.tn_t420_opportunity_winper) {
                data.tn_t420_opportunity_winper.forEach((e) => {
                    list.value.push({
                        pkid: e.tn_id,
                        title: e.tn_customer,
                        value: e.userinfoname,
                        label: e.tn_created,
                        tn_sumscore: e.tn_sumscore
                    });
                });
                let itemcount = list.value.length;
                if (data.__paging && data.__paging.__itemcount) {
                    itemcount = data.__paging.__itemcount;
                }
                res({ allCount: itemcount, len: list.value.length });
            }
            else {
                res({ allCount: 0, len: 0 });
            }
        });
    };

    const labelClass = (item) => {
      console.log('labelClass', item)
      if (parseInt(item.tn_sumscore) >= 80) {
        return 'color: blue'
      }

      return ''
    }
    onMounted(() => {
        // 计算list 可用的高度
        const heightDiff = window.innerHeight - heardWrap.value.offsetHeight;
        listWrap.value.style.height = heightDiff + "px";
    });

    return {
      showPopover,
      heardWrap,
      listWrap,
      searchValue,
      listPullRefreshWrapRef,
      add,
      onSearch,
      list,
      resetList,
      fetch,
      onConfirmDate,
      advCustInfoData,
      showCalendar,
      advSearch_reset,
      advSearch_ok,
      startMin,
      showAdvBtn,
      labelClass
    };
  },
});
</script>

<style scoped lang="less">
// 修改背景样式 dropdownMenu
.dropdownMenu {
  /deep/ .van-dropdown-menu__bar {
    background: transparent;
    z-index: 1;
    .van-ellipsis {
      color: #fff;
    }
    .van-dropdown-menu__title--active {
      color: #fff;
    }
  }
}

:deep(.van-dropdown-menu__bar) {
  z-index: 0;
}

:deep(.van-dropdown-menu__title--active) {
  color: var(--van-text-color);
}

:deep(.van-button--danger) {
  color: var(--van-white);
  background: var(--van-primary-color);
  border: var(--van-button-border-width) solid var(--van-primary-color);
}

:deep(.van-calendar__day--start) {
  color: var(--van-white);
  background: var(--van-primary-color);
}

:deep(.van-calendar__day--end) {
  color: var(--van-white);
  background: var(--van-primary-color);
}

.searchWrap {
  align-items: center;
}

.listWrap {
  overflow: auto;
}

.div{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px;
}
</style>
